"use strict";

var _interopRequireDefault = require("/Users/yinpeng/Sites/gitlab/layaair-pro-web/performance/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("core-js/modules/es.array.slice.js");

require("core-js/modules/es.function.name.js");

require("core-js/modules/es.number.to-fixed.js");

require("core-js/modules/es.object.to-string.js");

require("regenerator-runtime/runtime.js");

var _toConsumableArray2 = _interopRequireDefault(require("/Users/yinpeng/Sites/gitlab/layaair-pro-web/performance/node_modules/@babel/runtime/helpers/toConsumableArray.js"));

var _asyncToGenerator2 = _interopRequireDefault(require("/Users/yinpeng/Sites/gitlab/layaair-pro-web/performance/node_modules/@babel/runtime/helpers/asyncToGenerator.js"));

var _index = _interopRequireDefault(require("@/components/ReportNav/index.vue"));

var _common = require("@/api/common");

var _report = require("@/api/report");

var _LineChart = _interopRequireDefault(require("@/components/Chart/LineChart.vue"));

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = {
  name: 'ReportAutoTest',
  components: {
    ReportNav: _index.default,
    LineChart: _LineChart.default
  },
  data: function data() {
    return {
      loading: true,
      projectId: '',
      reportId: '',
      pageConfig: {
        testData: [],
        chartInfo: []
      },
      pageKey: '',
      defaultProps: {
        children: 'children',
        label: 'label'
      },
      chartData: {
        id: 'autoTest',
        data: {}
      },
      tableData: [{
        title: 'CPU(ms)',
        start: 0,
        end: 0,
        total: 0,
        avg: 0,
        min: 0,
        max: 0
      }, {
        title: 'drawCall',
        start: 0,
        end: 0,
        total: 0,
        avg: 0,
        min: 0,
        max: 0
      }, {
        title: 'triangle(千面)',
        start: 0,
        end: 0,
        total: 0,
        avg: 0,
        min: 0,
        max: 0
      }, {
        title: 'render(ms)',
        start: 0,
        end: 0,
        total: 0,
        avg: 0,
        min: 0,
        max: 0
      }, {
        title: 'textureMemory(MB)',
        start: 0,
        end: 0,
        total: 0,
        avg: 0,
        min: 0,
        max: 0
      }]
    };
  },
  created: function created() {
    var _this = this;

    return (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var informRes, fileRes, chartData;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this.projectId = _this.$route.params.projectId;
              _this.reportId = _this.$route.params.reportId;

              if (!_this.$route.meta.pageKey) {
                _context.next = 16;
                break;
              }

              _this.pageKey = _this.$route.meta.pageKey;
              _context.next = 6;
              return (0, _report.informJSONInfo)({
                inform_id: _this.reportId,
                key: _this.pageKey
              });

            case 6:
              informRes = _context.sent;
              _context.next = 9;
              return (0, _common.getFile)(informRes.data.data);

            case 9:
              fileRes = _context.sent;
              _this.pageConfig = fileRes.data;
              console.log('pageConfig', _this.pageConfig);
              chartData = _this.pageConfig.chartInfo[0];
              chartData.data.seriesdata[0].markArea = {
                itemStyle: {
                  color: 'rgba(255, 173, 177, 0.4)'
                },
                data: []
              };
              _this.chartData = chartData;

              _this.changeTable(0, _this.chartData.data.totalFrame);

            case 16:
              _this.loading = false;

            case 17:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))();
  },
  mounted: function mounted() {},
  methods: {
    checkChange: function checkChange() {
      // console.log('checkChange', arguments)
      var list = this.$refs.tree.getCheckedNodes();
      console.log(list);
      var data = [];

      for (var i = 0; i < list.length; i++) {
        data.push([{
          name: list[i].label,
          xAxis: list[i].startFrame
        }, {
          xAxis: list[i].endFrame
        }]);
      }

      this.chartData.data.seriesdata[0].markArea.data = data;
      console.log(this.chartData.data, this.$refs.chart);
      this.$refs.chart.drawLine();

      if (list.length) {
        this.changeTable(list[0].startFrame, list[0].endFrame);
      } else {
        this.changeTable(0, this.chartData.data.totalFrame);
      }
    },
    changeTable: function changeTable(start, end) {
      var list = this.chartData.data.seriesdata;
      var table = [];

      for (var i = 0; i < list.length; i++) {
        var data = list[i].data.slice(start, end);
        var one = {
          title: list[i].name,
          start: start,
          end: end,
          total: end - start,
          min: Math.min.apply(Math, (0, _toConsumableArray2.default)(data)),
          max: Math.max.apply(Math, (0, _toConsumableArray2.default)(data)),
          avg: (data.reduce(function (a, b) {
            return a + b;
          }) / data.length).toFixed(2)
        };
        table.push(one);
      }

      this.tableData = table;
    }
  }
};
exports.default = _default;